export const formatDate = (date: Date) => {
  const newDate = new Date(date).toISOString();
  return new Date(newDate).toDateString();
};

export const formatDateTime = (date: Date) => {
  const newDate = new Date(date).toISOString().replace("T", " ");
  return new Date(newDate).toDateString();
};

export const compareDate = (dateInput: Date | string): boolean => {
  const expiryDate = new Date(dateInput);
  if (Number.isNaN(expiryDate.getTime())) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  expiryDate.setHours(0, 0, 0, 0);
  return today > expiryDate;
};
